import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CampaignListComponent } from './campaign/campaign-list/campaign-list.component';
import { CampaignDetailComponent } from './campaign/campaign-detail/campaign-detail.component';
import { RestaurantListComponent } from './restaurant/restaurant-list/restaurant-list.component';
import { RestaurantDetailComponent } from './restaurant/restaurant-detail/restaurant-detail.component';
import { DownloadComponent } from './download/download.component';
import { TermsComponent } from './public/terms/terms.component';
import { PlansComponent } from './public/plans/plans.component';
import { CategoryComponent } from './category/category.component';
import { MenuWrapperComponent } from '../../shared/wrappers/menu-wrapper/menu-wrapper.component';
import { PerformanceComponent } from './public/performance/performance.component';
import { DeliveryListComponent } from './delivery/delivery-list/delivery-list.component';
import { AppExclusionTutorialComponent } from './app-exclusion-tutorial/app-exclusion-tutorial.component';
import { EventComponent } from './event/event.component';
import { DynamicLinkComponent } from './dynamic-link/dynamic-link.component';

const routes: Routes = [
  { path: 'termos', component: TermsComponent },
  { path: 'policy', component: TermsComponent },
  { path: 'performance', component: PerformanceComponent },
  {
    path: '',
    component: MenuWrapperComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'home/:cityId',
        component: HomeComponent,
      },
      {
        path: 'baixe-o-app',
        component: DownloadComponent,
      },
      {
        path: 'cupom/:id',
        component: CampaignDetailComponent,
      },
      {
        path: 'cupons',
        component: CampaignListComponent,
      },
      {
        path: 'delivery',
        component: DeliveryListComponent,
      },
      {
        path: 'restaurante/:slug',
        component: RestaurantDetailComponent,
      },
      {
        path: 'categoria/:slug',
        component: CategoryComponent,
      },
      {
        path: 'evento/:id',
        component: EventComponent,
      },
      {
        path: 'restaurantes',
        component: RestaurantListComponent,
      },
      {
        path: 'planos',
        component: PlansComponent,
      },
      {
        path: 'exclusao-de-conta',
        component: AppExclusionTutorialComponent,
      },
      {
        path: 'campaignId',
        component: DynamicLinkComponent,
      },
      {
        path: 'campaignid',
        component: DynamicLinkComponent,
      },
      {
        path: 'deliveryCampaignId',
        component: DynamicLinkComponent,
      },
      {
        path: 'deliverycampaignid',
        component: DynamicLinkComponent,
      },
      {
        path: 'commercialPlaceIdArgument',
        component: DynamicLinkComponent,
      },
      {
        path: 'commercialplaceidargument',
        component: DynamicLinkComponent,
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: '',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WebappRoutingModule {}
